<template>
    <el-container>
      <el-table :span-method="objectSpanMethod" :data="list" :height="searchTableHeight" height-current-row @row-click="clickTable" class="table">
        <el-table-column prop="date" label="日付" width="120">
            <template slot-scope="scope">
                <el-link>{{scope.row.date}}</el-link>
            </template>
        </el-table-column>
        <el-table-column prop="index" label="時間(24h)" width="120" />
        <el-table-column v-for="property in propertys" :key="property.prop" :prop="property.prop" :label="property.label" width="50" />
        <InfiniteLoading slot="append" spinner="spiral" @infinite="infiniteHandler" force-use-infinite-wrapper=".el-table__body-wrapper" ref="infiniteLoading" >
            <!--全件表示時、「No more data :)」非表示-->
            <!--全件表示時、「No results :(」非表示-->
            <div slot="no-more" />
            <div slot="no-results" />
        </InfiniteLoading>
      </el-table>
    </el-container>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
export default {
    props: {
        reportData: {
            type: Array,
            default: () => [],
            required: false
        },
        propertys: {
            type: Array,
            default: () => [],
            required: false
        }
    },
    data() {
        return {
            list: [],
            page: 0,
            maxPage: 0,
            showDailyCount: 10,
            tableHeight: 0
        }
    },
    
    mounted() {
        this.makeTableInstance()
    },
    
    methods: {
        objectSpanMethod({ rowIndex, columnIndex}) {
            if (columnIndex === 0) {
                if (rowIndex % 4 === 0) {
                    return {
                        rowspan: 4,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            } 
        },
        clickTable(row) {
            if (row.index === "最大人数(人)") {
                this.$emit('update', row)
            }
        },
        createTableData(page) {

            let maxHoursData = {};
            let minHoursData = {};
            let densityHoursData = {};
            let densityLevelHousrsData = {};
            let hoursDataList = [];
            let prop_str = '';

            try {
                const property = this.propertys
                const listIndex = page * this.showDailyCount
                this.reportData.forEach((daily_stream,daily_index) => {
                    if (daily_index < listIndex || daily_index > listIndex + 9) {
                        return;
                    }
                    daily_stream.forEach((stream, index) => {
                        property.some((pp, idx) => {
                            if (index === idx + 2) {
                                prop_str = pp.prop
                                return true
                            } else if (index === 1) {
                                prop_str = "index"
                                return true
                            } else if (index === 0) {
                                prop_str = "date"
                                return true
                            }
                            
                        });
                        this.$set(maxHoursData, prop_str, stream.max)
                        this.$set(minHoursData, prop_str, stream.min)
                        this.$set(densityHoursData, prop_str, stream.density)
                        this.$set(densityLevelHousrsData, prop_str, stream.density_level)
                    });
                    hoursDataList.push(JSON.parse(JSON.stringify(maxHoursData)));
                    hoursDataList.push(JSON.parse(JSON.stringify(minHoursData)));
                    hoursDataList.push(JSON.parse(JSON.stringify(densityHoursData)));
                    hoursDataList.push(JSON.parse(JSON.stringify(densityLevelHousrsData)));
                })

            } catch (e) {
                console.log(e)
            }
            return hoursDataList
                
        },
        infiniteHandler($state) {
            if (this.page < this.maxPage) {
                this.page += 1
                this.list = this.list.concat(this.createTableData(this.page))
                $state.loaded();
            } else {
                $state.complete();
            }
        },
        // reportData新規作成 or 変更時のみ実行
        makeTableInstance() {
            // 初期化
            this.list = []
            this.page = 0
            this.maxPage = 0
            
            this.list = this.createTableData(this.page)
            // ページ数 0スタート
            this.maxPage = Math.ceil(this.reportData.length / this.showDailyCount) - 1
        }
    },
    computed: {
        searchTableHeight() {
            if (this.reportData.length === 1) {
                return 255
            }
            return 435
        }
    },
    
    components: {
        InfiniteLoading
    },
    
    watch: {
        // 過去データ検索実行時
        reportData() {
            document.querySelector(".el-table__body").scrollIntoView(true)
            this.$refs.infiniteLoading.stateChanger.reset()
            this.makeTableInstance()
        }
    }
};

</script>

<style scoped>
    .el-table >>> th, .el-table >>> .header-cell{
        color: dimgray;
        background-color: lightsteelblue;
    }

</style>